import { useQuery } from '@tanstack/react-query';
import { api, ApiError } from '../api/client.js';

/**
 * Fetches the current authenticated user from `/auth/me`.
 *
 * Returns TanStack Query shape: { data, isLoading, error, ... }.
 *
 *   data === undefined while loading
 *   data === null     when the user is not signed in (401 silently treated as "no user")
 *   data === { ... }  when signed in — shape per MODULE_SPECS/admin.md §Auth
 */
export function useCurrentUser() {
  return useQuery({
    queryKey: ['auth', 'me'],
    queryFn: async () => {
      try {
        return await api.get('/auth/me');
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) {
          return null; // Not signed in — not an error, just no user.
        }
        throw err;
      }
    },
    staleTime: 60_000, // 1 min — user + roles rarely change within a session
    retry: false,
  });
}
